import * as Actions from "../redux/adminSession";
import * as OmniDataAPI from "../../data/omniDataAPI";
import * as SearchSessionActions from "../../state/redux/searchSession";
import * as UserSessionActions from "../../state/redux/userSession";

import { call, put, select, takeLatest } from "redux-saga/effects";
import { deepCopyObject, isValidUUID } from "../../utils/helpers";

import constants from "../../assets/constants";
import { createNewRelationship } from "../../data/omniDataModel";
import { v4 as uuid } from "uuid";

export function* loadAdministratorODM({ payload }) {
  try {
    //clear out the existing information
    yield put(Actions.setAdministratorODMRequest(null));
    if (isValidUUID(payload)) {
      //payload is a valid UUID
      let administratorODM = yield call(OmniDataAPI.getAdministrator, payload);

      if (administratorODM == null) {
        yield put(Actions.adminSessionRequestFail("OmniDataAPI.getAdministrator FAILED"));
      } else {
        yield put(Actions.setAdministratorODMRequest(administratorODM));
        yield put(Actions.loadAdministratorODMSuccess());
      }
    } else {
      yield put(Actions.adminSessionRequestFail("Bad Administrator _id"));
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* setAdministratorODM({ payload }) {
  try {
    //Validate Object

    // if (payload == null) {
    //   //clear out set items
    //   yield put(Actions.setAdministratorAssessmentsRequest(null));
    //   yield put(Actions.setAdministratorPatientsRequest(null));
    // } else {
    //   //Do all ancillary data loads here
    //   yield put(Actions.loadAdministratorAssessmentsRequest(payload._id));
    //   yield put(Actions.loadAdministratorPatientsRequest(payload._id));
    // }

    yield put(Actions.setAdministratorODMSuccess(payload));
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* updateAdministrator({ payload }) {
  try {
    if (payload._id == null) {
      //CREATE
      payload._id = uuid();
      let newAdministrator = yield call(OmniDataAPI.createAdministrator, payload);
      if (newAdministrator == null) {
        yield put(Actions.adminSessionRequestFail("OmniDataAPI.createAdministrator FAILED"));
      } else {
        yield put(Actions.setAdministratorODMRequest(newAdministrator));
        yield put(Actions.updateAdministratorSuccess());
      }
    } else if (isValidUUID(payload._id)) {
      //UPDATE
      let newAdministrator = yield call(OmniDataAPI.updateAdministrator, payload);
      if (newAdministrator == null) {
        yield put(Actions.adminSessionRequestFail("OmniDataAPI.createAdministrator FAILED"));
      } else {
        yield put(Actions.setAdministratorODMRequest(newAdministrator));
        yield put(Actions.updateAdministratorSuccess());
        yield put(UserSessionActions.reflectUpdatedUserODMRequest(newAdministrator));
      }
    } else {
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* deleteAdministrator({ payload }) {
  try {
    //payload is UUID
    if (isValidUUID(payload)) {
      const administrator = yield select(Actions.administratorODMSelector);
      let deletedAdministrator = yield call(OmniDataAPI.deleteAdministrator, payload);
      if (deletedAdministrator == null) {
        yield put(Actions.deleteAdministratorSuccess(administrator));
        //this method assumes that an ID alone is a delete
        //yield put(AdminSessionActions.reflectUpdatedAdministratorODMRequest(administrator));
      }
    }
    const administratorODM = yield select(Actions.administratorODMSelector);
    if (administratorODM != null && payload === administratorODM._id) {
      yield put(Actions.setAdministratorODMRequest(null));
    } else {
      yield put(Actions.adminSessionRequestFail("deleteAdministrator: invalid UUID()"));
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* updateConversationConfiguration({ payload }) {
  try {
    //payload is ConversationConfigurationODM

    const currentList = yield select(Actions.allConversationConfigurationsSelector);

    if (payload._id == null) {
      //CREATE
      payload._id = uuid();
      let newConversationConfiguration = yield call(
        OmniDataAPI.createConversationConfiguration,
        payload
      );
      if (newConversationConfiguration == null) {
        yield put(
          Actions.adminSessionRequestFail("OmniDataAPI.createConversationConfiguration FAILED")
        );
      } else {
        const newList =
          currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id); //creates a copy of the list
        newList.push(newConversationConfiguration);
        yield put(Actions.updateConversationConfigurationSuccess(newList));
      }
    } else if (isValidUUID(payload._id)) {
      //UPDATE
      let newConversationConfiguration = yield call(
        OmniDataAPI.updateConversationConfiguration,
        payload
      );
      if (newConversationConfiguration == null) {
        yield put(
          Actions.adminSessionRequestFail("OmniDataAPI.updateConversationConfiguration FAILED")
        );
      } else {
        const newList =
          currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id);
        newList.push(newConversationConfiguration);
        //set the newly updated as the focus
        yield put(Actions.updateConversationConfigurationSuccess(newList));
      }
    } else {
      yield put(Actions.adminSessionRequestFail("Bad ConversationConfigurationODM"));
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* deleteConversationConfiguration({ payload }) {
  try {
    if (isValidUUID(payload)) {
      let ConversationConfiguration = yield call(
        OmniDataAPI.deleteConversationConfiguration,
        payload
      );
      if (ConversationConfiguration != null) {
        const ConversationConfigurations = yield select(
          Actions.allConversationConfigurationsSelector
        );
        const newConversationConfigurations =
          ConversationConfigurations == null
            ? []
            : ConversationConfigurations.filter(obj => obj._id !== payload);
        yield put(Actions.deleteConversationConfigurationSuccess(newConversationConfigurations));
      }
    } else {
      yield put(Actions.adminSessionRequestFail("deleteConversationConfiguration: invalid UUID()"));
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* loadPractices({ payload }) {
  try {
    let theReturn = yield call(OmniDataAPI.getAllPractices);

    yield put(Actions.loadPracticesSuccess(theReturn));
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* reflectUpdatedPracticeODM({ payload }) {
  try {
    if (isValidUUID(payload)) {
      const currentList = yield select(Actions.practiceODMsSelector);
      if (currentList != null) {
        //prevents a [] from being returned, thinking this has been initialized from NULL
        const newList = currentList.filter(obj => obj._id !== payload); //creates a copy of the list
        yield put(Actions.reflectUpdatedPracticeODMSuccess(newList));
      }
    } else {
      const currentList = yield select(Actions.practiceODMsSelector);
      const newList = currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id); //creates a copy of the list
      newList.push(payload);
      yield put(Actions.reflectUpdatedPracticeODMSuccess(newList));
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* loadPatients({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    let currentCacheInvalid = false;
    const pagination = yield select(Actions.patientPaginationSelector);
    if (
      payload.pageSize !== pagination.pageSize ||
      JSON.stringify(payload.query) !== JSON.stringify(pagination.query) ||
      JSON.stringify(payload.sort) !== JSON.stringify(pagination.sort) ||
      payload.invalidateCache
    ) {
      //something fundamental has changed
      currentCacheInvalid = true;
      payload.invalidateCache = false;
    }

    let patientPages = yield select(Actions.patientPagesSelector);
    if (!currentCacheInvalid && patientPages.hasOwnProperty(payload.pageIndex)) {
      yield put(
        Actions.loadPatientsSuccess({
          pages: patientPages,
          items: patientPages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    } else {
      let theReturn = yield call(OmniDataAPI.searchPatients, payload);

      //upate the pagination
      payload.totalItems = theReturn.pageInfo.itemCount;

      if (currentCacheInvalid) {
        patientPages = {};
      }
      patientPages[payload.pageIndex] = { odms: theReturn.items };

      yield put(
        Actions.loadPatientsSuccess({
          pages: patientPages,
          items: patientPages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* reflectUpdatedPatientODM({ payload }) {
  try {
    //dont care about the payload for now
    const currentPagination = yield select(Actions.patientPaginationSelector);
    currentPagination.invalidateCache = true;
    yield put(Actions.loadPatientsRequest(currentPagination));
    yield put(Actions.reflectUpdatedPatientODMSuccess());
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* loadPartners({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    let currentCacheInvalid = false;
    const pagination = yield select(Actions.partnerPaginationSelector);
    if (
      payload.pageSize !== pagination.pageSize ||
      JSON.stringify(payload.query) !== JSON.stringify(pagination.query) ||
      JSON.stringify(payload.sort) !== JSON.stringify(pagination.sort) ||
      payload.invalidateCache
    ) {
      //something fundamental has changed
      currentCacheInvalid = true;
      payload.invalidateCache = false;
    }

    let partnerPages = yield select(Actions.partnerPagesSelector);
    if (!currentCacheInvalid && partnerPages.hasOwnProperty(payload.pageIndex)) {
      yield put(
        Actions.loadPartnersSuccess({
          pages: partnerPages,
          items: partnerPages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    } else {
      let theReturn = yield call(OmniDataAPI.searchPartners, payload);

      //upate the pagination
      payload.totalItems = theReturn.pageInfo.itemCount;

      if (currentCacheInvalid) {
        partnerPages = {};
      }
      partnerPages[payload.pageIndex] = { odms: theReturn.items };

      yield put(
        Actions.loadPartnersSuccess({
          pages: partnerPages,
          items: partnerPages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* reflectUpdatedPartnerODM({ payload }) {
  try {
    //dont care about the payload for now
    const currentPagination = yield select(Actions.partnerPaginationSelector);
    currentPagination.invalidateCache = true;
    yield put(Actions.loadPartnersRequest(currentPagination));
    yield put(Actions.reflectUpdatedPartnerODMSuccess());
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* loadProviders({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    let currentCacheInvalid = false;
    const pagination = yield select(Actions.providerPaginationSelector);
    if (
      payload.pageSize !== pagination.pageSize ||
      JSON.stringify(payload.query) !== JSON.stringify(pagination.query) ||
      JSON.stringify(payload.sort) !== JSON.stringify(pagination.sort) ||
      payload.invalidateCache
    ) {
      //something fundamental has changed
      currentCacheInvalid = true;
      payload.invalidateCache = false;
    }

    let providerPages = yield select(Actions.providerPagesSelector);
    if (!currentCacheInvalid && providerPages.hasOwnProperty(payload.pageIndex)) {
      yield put(
        Actions.loadProvidersSuccess({
          pages: providerPages,
          items: providerPages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    } else {
      let theReturn = yield call(OmniDataAPI.searchProviders, payload);

      //upate the pagination
      payload.totalItems = theReturn.pageInfo.itemCount;

      if (currentCacheInvalid) {
        providerPages = {};
      }
      providerPages[payload.pageIndex] = { odms: theReturn.items };

      yield put(
        Actions.loadProvidersSuccess({
          pages: providerPages,
          items: providerPages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* reflectUpdatedProviderODM({ payload }) {
  try {
    if (isValidUUID(payload)) {
      const currentList = yield select(Actions.providerODMsSelector);
      if (currentList != null) {
        //prevents a [] from being returned, thinking this has been initialized from NULL
        const newList = currentList.filter(obj => obj._id !== payload); //creates a copy of the list
        yield put(Actions.reflectUpdatedProviderODMSuccess(newList));
      }
    } else {
      const currentList = yield select(Actions.providerODMsSelector);
      const newList = currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id); //creates a copy of the list
      newList.push(payload);
      yield put(Actions.reflectUpdatedProviderODMSuccess(newList));
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* loadCommInvites({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    let currentCacheInvalid = false;
    const pagination = yield select(Actions.commInvitePaginationSelector);
    if (
      payload.pageSize !== pagination.pageSize ||
      JSON.stringify(payload.query) !== JSON.stringify(pagination.query) ||
      JSON.stringify(payload.sort) !== JSON.stringify(pagination.sort) ||
      payload.invalidateCache
    ) {
      //something fundamental has changed
      currentCacheInvalid = true;
      payload.invalidateCache = false;
    }

    let commInvitePages = yield select(Actions.commInvitePagesSelector);
    if (!currentCacheInvalid && commInvitePages.hasOwnProperty(payload.pageIndex)) {
      yield put(
        Actions.loadCommInvitesSuccess({
          pages: commInvitePages,
          items: commInvitePages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    } else {
      //move this out?

      let theReturn = yield call(OmniDataAPI.searchInvites, payload);

      //upate the pagination
      payload.totalItems = theReturn.pageInfo.itemCount;

      if (currentCacheInvalid) {
        commInvitePages = {};
      }
      commInvitePages[payload.pageIndex] = { odms: theReturn.items };

      yield put(
        Actions.loadCommInvitesSuccess({
          pages: commInvitePages,
          items: commInvitePages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* loadSharedInvites({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    let currentCacheInvalid = false;
    const pagination = yield select(Actions.sharedInvitePaginationSelector);
    if (
      payload.pageSize !== pagination.pageSize ||
      JSON.stringify(payload.query) !== JSON.stringify(pagination.query) ||
      JSON.stringify(payload.sort) !== JSON.stringify(pagination.sort) ||
      payload.invalidateCache
    ) {
      //something fundamental has changed
      currentCacheInvalid = true;
      payload.invalidateCache = false;
    }

    let sharedInvitePages = yield select(Actions.sharedInvitePagesSelector);
    if (!currentCacheInvalid && sharedInvitePages.hasOwnProperty(payload.pageIndex)) {
      yield put(
        Actions.loadSharedInvitesSuccess({
          pages: sharedInvitePages,
          items: sharedInvitePages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    } else {
      //move this out?
      payload.query["omniData.inviteType"] = constants.inviteType.shared;

      let deleteTarget = false;
      if (!payload.query.hasOwnProperty("omniData.target")) {
        deleteTarget = true;
        payload.query["omniData.target"] = { "#regex": "^((?!default shar).)*$", "#options": "i" };
      }

      let theReturn = yield call(OmniDataAPI.searchInvites, payload);

      if (deleteTarget) {
        delete payload.query["omniData.target"];
      }
      delete payload.query["omniData.inviteType"];

      //upate the pagination
      payload.totalItems = theReturn.pageInfo.itemCount;

      if (currentCacheInvalid) {
        sharedInvitePages = {};
      }
      sharedInvitePages[payload.pageIndex] = { odms: theReturn.items };

      yield put(
        Actions.loadSharedInvitesSuccess({
          pages: sharedInvitePages,
          items: sharedInvitePages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* loadAutoInvites({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    let currentCacheInvalid = false;
    const pagination = yield select(Actions.autoInvitePaginationSelector);
    if (
      payload.pageSize !== pagination.pageSize ||
      JSON.stringify(payload.query) !== JSON.stringify(pagination.query) ||
      JSON.stringify(payload.sort) !== JSON.stringify(pagination.sort) ||
      payload.invalidateCache
    ) {
      //something fundamental has changed
      currentCacheInvalid = true;
      payload.invalidateCache = false;
    }

    let autoInvitePages = yield select(Actions.autoInvitePagesSelector);
    if (!currentCacheInvalid && autoInvitePages.hasOwnProperty(payload.pageIndex)) {
      yield put(
        Actions.loadAutoInvitesSuccess({
          pages: autoInvitePages,
          items: autoInvitePages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    } else {
      //move this out?
      payload.query["omniData.inviteType"] = constants.inviteType.shared;

      let deleteTarget = false;
      if (!payload.query.hasOwnProperty("omniData.target")) {
        deleteTarget = true;

        payload.query["omniData.target"] = { "#regex": "default shar", "#options": "i" };
      }

      let theReturn = yield call(OmniDataAPI.searchInvites, payload);

      delete payload.query["omniData.inviteType"];
      if (deleteTarget) {
        delete payload.query["omniData.target"];
      }

      //upate the pagination
      payload.totalItems = theReturn.pageInfo.itemCount;

      if (currentCacheInvalid) {
        autoInvitePages = {};
      }
      autoInvitePages[payload.pageIndex] = { odms: theReturn.items };

      yield put(
        Actions.loadAutoInvitesSuccess({
          pages: autoInvitePages,
          items: autoInvitePages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* loadSingleInvites({ payload }) {
  try {
    //payload is a "pagination" from helpers.js

    let currentCacheInvalid = false;
    const pagination = yield select(Actions.singleInvitePaginationSelector);
    if (
      payload.pageSize !== pagination.pageSize ||
      JSON.stringify(payload.query) !== JSON.stringify(pagination.query) ||
      JSON.stringify(payload.sort) !== JSON.stringify(pagination.sort) ||
      payload.invalidateCache
    ) {
      //something fundamental has changed
      currentCacheInvalid = true;
      payload.invalidateCache = false;
    }

    let singleInvitePages = yield select(Actions.singleInvitePagesSelector);
    if (!currentCacheInvalid && singleInvitePages.hasOwnProperty(payload.pageIndex)) {
      yield put(
        Actions.loadSingleInvitesSuccess({
          pages: singleInvitePages,
          items: singleInvitePages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    } else {
      //move this out?
      payload.query["omniData.inviteType"] = constants.inviteType.single;

      let theReturn = yield call(OmniDataAPI.searchInvites, payload);

      delete payload.query["omniData.inviteType"];

      //upate the pagination
      payload.totalItems = theReturn.pageInfo.itemCount;

      if (currentCacheInvalid) {
        singleInvitePages = {};
      }
      singleInvitePages[payload.pageIndex] = { odms: theReturn.items };

      yield put(
        Actions.loadSingleInvitesSuccess({
          pages: singleInvitePages,
          items: singleInvitePages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* reflectUpdatedInviteODM({ payload }) {
  try {
    if (payload.omniData.inviteType === constants.inviteType.shared) {
      const sharedInvitePagesSelector = yield select(Actions.sharedInvitePagesSelector);
      let newPage = deepCopyObject(sharedInvitePagesSelector);
      newPage.invalidateCache = true;
      yield put(Actions.loadSingleInvitesRequest(newPage));
    } else {
      const singleInvitePagination = yield select(Actions.singleInvitePaginationSelector);
      let newPage = deepCopyObject(singleInvitePagination);
      newPage.invalidateCache = true;
      yield put(Actions.loadSingleInvitesRequest(newPage));
    }

    const searchInvitePagination = yield select(SearchSessionActions.inviteSearchPagesSelector);
    let newPage = deepCopyObject(searchInvitePagination);
    newPage.invalidateCache = true;
    yield put(SearchSessionActions.searchInvitesRequest(newPage));
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* loadReports({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    let currentCacheInvalid = false;
    const pagination = yield select(Actions.reportPaginationSelector);
    if (
      payload.pageSize !== pagination.pageSize ||
      JSON.stringify(payload.query) !== JSON.stringify(pagination.query) ||
      JSON.stringify(payload.sort) !== JSON.stringify(pagination.sort) ||
      payload.invalidateCache
    ) {
      //something fundamental has changed
      currentCacheInvalid = true;
      payload.invalidateCache = false;
    }

    let reportPages = yield select(Actions.reportPagesSelector);
    if (!currentCacheInvalid && reportPages.hasOwnProperty(payload.pageIndex)) {
      yield put(
        Actions.loadReportsSuccess({
          pages: reportPages,
          items: reportPages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    } else {
      let theReturn = yield call(OmniDataAPI.searchReports, payload);

      //upate the pagination
      payload.totalItems = theReturn.pageInfo.itemCount;

      if (currentCacheInvalid) {
        reportPages = {};
      }
      reportPages[payload.pageIndex] = { odms: theReturn.items };

      yield put(
        Actions.loadReportsSuccess({
          pages: reportPages,
          items: reportPages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }

  // try {
  //   let theReturn = yield call(OmniDataAPI.getAllReports);

  //   yield put(Actions.loadReportsSuccess(theReturn));
  // } catch (error) {
  //   yield put(Actions.adminSessionRequestFail(error));
  // }
}

export function* createReport({ payload }) {
  try {
    let newReport = yield call(OmniDataAPI.createReport, payload);

    if (newReport == null) {
      yield put(Actions.adminSessionRequestFail("OmniDataAPI.createReport FAILED"));
    } else {
      const currentList = yield select(Actions.reportODMsSelector);
      currentList.push(newReport);
      yield put(Actions.createReportSuccess(currentList.slice()));
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* deleteReport({ payload }) {
  try {
    if (isValidUUID(payload)) {
      let deletedReport = yield call(OmniDataAPI.deleteReport, payload);
      if (deletedReport != null) {
        //this method assumes that an ID alone is a delete
        const currentList = yield select(Actions.reportODMsSelector);
        if (currentList != null) {
          //prevents a [] from being returned, thinking this has been initialized from NULL
          const newList = currentList.filter(obj => obj._id !== payload); //creates a copy of the list
          yield put(Actions.deleteReportSuccess(newList));
        } else {
          yield put(Actions.adminSessionRequestFail("deleteReport: bad return"));
        }
      }
    } else {
      yield put(Actions.adminSessionRequestFail("deleteReport: bad UUID"));
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* reflectUpdatedReportODM({ payload }) {
  try {
    if (isValidUUID(payload)) {
      const currentList = yield select(Actions.reportODMsSelector);
      if (currentList != null) {
        //prevents a [] from being returned, thinking this has been initialized from NULL
        const newList = currentList.filter(obj => obj._id !== payload); //creates a copy of the list
        yield put(Actions.reflectUpdatedReportODMSuccess(newList));
      }
    } else {
      const currentList = yield select(Actions.reportODMsSelector);
      const newList = currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id); //creates a copy of the list
      newList.push(payload);
      yield put(Actions.reflectUpdatedReportODMSuccess(newList));
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* setReportODM({ payload }) {
  try {
    yield put(Actions.setReportODMSuccess(payload));
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* loadCommunicationRequests({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    let currentCacheInvalid = false;
    const pagination = yield select(Actions.communicationRequestPaginationSelector);
    if (
      payload.pageSize !== pagination.pageSize ||
      JSON.stringify(payload.query) !== JSON.stringify(pagination.query) ||
      JSON.stringify(payload.sort) !== JSON.stringify(pagination.sort) ||
      payload.invalidateCache
    ) {
      //something fundamental has changed
      currentCacheInvalid = true;
      payload.invalidateCache = false;
    }

    let communicationRequestPages = yield select(Actions.communicationRequestPagesSelector);
    if (!currentCacheInvalid && communicationRequestPages.hasOwnProperty(payload.pageIndex)) {
      yield put(
        Actions.loadCommunicationRequestsSuccess({
          pages: communicationRequestPages,
          items: communicationRequestPages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    } else {
      let theReturn = yield call(OmniDataAPI.searchCommunicationRequests, payload);

      //upate the pagination
      payload.totalItems = theReturn.pageInfo.itemCount;

      if (currentCacheInvalid) {
        communicationRequestPages = {};
      }
      communicationRequestPages[payload.pageIndex] = { odms: theReturn.items };

      yield put(
        Actions.loadCommunicationRequestsSuccess({
          pages: communicationRequestPages,
          items: communicationRequestPages[payload.pageIndex].odms,
          pagination: payload,
        })
      );
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* updateCommunicationRequest({ payload }) {
  try {
    //guard against invalid queries
    if (
      payload.omniData.destinations.to.inviteQuery != null &&
      Object.keys(payload.omniData.destinations.to.inviteQuery).length === 0
    ) {
      payload.omniData.destinations.to.inviteQuery = null;
    }
    if (
      payload.omniData.destinations.to.partnerQuery != null &&
      Object.keys(payload.omniData.destinations.to.partnerQuery).length === 0
    ) {
      payload.omniData.destinations.to.partnerQuery = null;
    }

    if (payload._id == null) {
      let newCommunicationRequest = yield call(OmniDataAPI.createCommunicationRequest, payload);
      if (newCommunicationRequest == null) {
        yield put(Actions.adminSessionRequestFail("OmniDataAPI.createCommunicationRequest FAILED"));
      } else {
        yield put(Actions.updateCommunicationRequestSuccess());
        yield put(Actions.reflectUpdatedCommunicationRequestODMRequest(newCommunicationRequest));
      }
    } else if (isValidUUID(payload._id)) {
      //UPDATE
      let newCommunicationRequest = yield call(OmniDataAPI.updateCommunicationRequest, payload);
      if (newCommunicationRequest == null) {
        yield put(Actions.adminSessionRequestFail("OmniDataAPI.updateCommunicationRequest FAILED"));
      } else {
        yield put(Actions.updateCommunicationRequestSuccess());
        yield put(Actions.reflectUpdatedCommunicationRequestODMRequest(newCommunicationRequest));
      }
    } else {
      yield put(Actions.adminSessionRequestFail("OmniDataAPI.UpdateCommunicationRequest FAILED"));
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* deleteCommunicationRequest({ payload }) {
  try {
    if (isValidUUID(payload)) {
      let deletedCommunicationRequest = yield call(OmniDataAPI.deleteCommunicationRequest, payload);
      if (deletedCommunicationRequest != null) {
        //this method assumes that an ID alone is a delete
        const currentList = yield select(Actions.communicationRequestODMsSelector);
        if (currentList != null) {
          //prevents a [] from being returned, thinking this has been initialized from NULL
          const newList = currentList.filter(obj => obj._id !== payload); //creates a copy of the list

          yield put(Actions.deleteCommunicationRequestSuccess(newList));
        } else {
          yield put(Actions.adminSessionRequestFail("deleteCommunicationRequest: bad return"));
        }
      }
    } else {
      yield put(Actions.adminSessionRequestFail("deleteCommunicationRequest: bad UUID"));
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* reflectUpdatedCommunicationRequestODM({ payload }) {
  try {
    if (isValidUUID(payload)) {
      const currentList = yield select(Actions.communicationRequestODMsSelector);
      if (currentList != null) {
        //prevents a [] from being returned, thinking this has been initialized from NULL
        const newList = currentList.filter(obj => obj._id !== payload); //creates a copy of the list
        yield put(Actions.reflectUpdatedCommunicationRequestODMSuccess(newList));
      }
    } else {
      const currentList = yield select(Actions.communicationRequestODMsSelector);
      const newList = currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id); //creates a copy of the list
      newList.push(payload);
      yield put(Actions.reflectUpdatedCommunicationRequestODMSuccess(newList));
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* loadCommunicationTemplates({ payload }) {
  try {
    let theReturn = yield call(OmniDataAPI.getAllCommunicationTemplates);

    yield put(Actions.loadCommunicationTemplatesSuccess(theReturn));
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* updateCommunicationTemplate({ payload }) {
  try {
    if (payload._id == null) {
      // payload.omniData.sendDate = formatISO(new Date());
      // payload.omniData.destinations.to.inviteQuery = "unknown";
      // payload.omniData.destinations.to.partnerQuery = "unknown";

      let newCommunicationTemplate = yield call(OmniDataAPI.createCommunicationTemplate, payload);
      if (newCommunicationTemplate == null) {
        yield put(
          Actions.adminSessionRequestFail("OmniDataAPI.createCommunicationTemplate FAILED")
        );
      } else {
        // yield put(Actions.setCommunicationTemplateODMRequest(newCommunicationTemplate));
        yield put(Actions.updateCommunicationTemplateSuccess());
      }
    } else if (isValidUUID(payload._id)) {
      //UPDATE
      let newCommunicationTemplate = yield call(OmniDataAPI.updateCommunicationTemplate, payload);
      if (newCommunicationTemplate == null) {
        yield put(
          Actions.adminSessionRequestFail("OmniDataAPI.createCommunicationTemplate FAILED")
        );
      } else {
        yield put(Actions.updateCommunicationTemplateSuccess());
        yield put(Actions.reflectUpdatedCommunicationTemplateODMRequest(newCommunicationTemplate));
      }
    } else {
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* deleteCommunicationTemplate({ payload }) {
  try {
    if (isValidUUID(payload)) {
      let deletedCommunicationTemplate = yield call(
        OmniDataAPI.deleteCommunicationTemplate,
        payload
      );
      if (deletedCommunicationTemplate != null) {
        //this method assumes that an ID alone is a delete
        const currentList = yield select(Actions.communicationTemplateODMsSelector);
        if (currentList != null) {
          //prevents a [] from being returned, thinking this has been initialized from NULL
          const newList = currentList.filter(obj => obj._id !== payload); //creates a copy of the list
          yield put(Actions.deleteCommunicationTemplateSuccess(newList));
        } else {
          yield put(Actions.adminSessionRequestFail("deleteCommunicationTemplate: bad return"));
        }
      }
    } else {
      yield put(Actions.adminSessionRequestFail("deleteCommunicationTemplate: bad UUID"));
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* reflectUpdatedCommunicationTemplateODM({ payload }) {
  try {
    if (isValidUUID(payload)) {
      const currentList = yield select(Actions.communicationTemplateODMsSelector);
      if (currentList != null) {
        //prevents a [] from being returned, thinking this has been initialized from NULL
        const newList = currentList.filter(obj => obj._id !== payload); //creates a copy of the list
        yield put(Actions.reflectUpdatedCommunicationTemplateODMSuccess(newList));
      }
    } else {
      const currentList = yield select(Actions.communicationTemplateODMsSelector);
      const newList = currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id); //creates a copy of the list
      newList.push(payload);
      yield put(Actions.reflectUpdatedCommunicationTemplateODMSuccess(newList));
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

export function* prosecuteCampaign({ payload }) {
  try {
    //payload is a communicationRequestODM
    let result = yield call(OmniDataAPI.prosecuteCampaign, payload._id);
    if (result == null) {
      yield put(Actions.adminSessionRequestFail("OmniDataAPI.prosecuteCampaign FAILED"));
    } else {
      // payload.omniData.batchId = result._id;

      //todo add a check for the Batch id, so we can do the state lookup in the object.
      let newRelationship = createNewRelationship(constants.omniRelationshipUserTypes.campaign);

      newRelationship._id = result._id;
      newRelationship.type = "campaign";
      newRelationship.skipValidation = true;

      payload.omniRelationships.relatedData.push(newRelationship);

      //marshall the result date here (the sent and soforth)

      yield put(Actions.updateCommunicationRequestRequest(payload));

      yield put(Actions.prosecuteCampaignSuccess());
    }
  } catch (error) {
    yield put(Actions.adminSessionRequestFail(error));
  }
}

//  saga
export default function* adminDataSaga() {
  yield takeLatest(Actions.loadAdministratorODMRequest, loadAdministratorODM);
  yield takeLatest(Actions.setAdministratorODMRequest, setAdministratorODM);
  yield takeLatest(Actions.updateAdministratorRequest, updateAdministrator);
  yield takeLatest(Actions.deleteAdministratorRequest, deleteAdministrator);

  yield takeLatest(Actions.updateConversationConfigurationRequest, updateConversationConfiguration);
  yield takeLatest(Actions.deleteConversationConfigurationRequest, deleteConversationConfiguration);

  yield takeLatest(Actions.loadPracticesRequest, loadPractices);
  yield takeLatest(Actions.reflectUpdatedPracticeODMRequest, reflectUpdatedPracticeODM);
  yield takeLatest(Actions.loadPatientsRequest, loadPatients);
  yield takeLatest(Actions.reflectUpdatedPatientODMRequest, reflectUpdatedPatientODM);
  yield takeLatest(Actions.loadPartnersRequest, loadPartners);
  yield takeLatest(Actions.reflectUpdatedPartnerODMRequest, reflectUpdatedPartnerODM);
  yield takeLatest(Actions.loadProvidersRequest, loadProviders);
  yield takeLatest(Actions.reflectUpdatedProviderODMRequest, reflectUpdatedProviderODM);

  yield takeLatest(Actions.loadCommInvitesRequest, loadCommInvites);
  yield takeLatest(Actions.loadSharedInvitesRequest, loadSharedInvites);
  yield takeLatest(Actions.loadAutoInvitesRequest, loadAutoInvites);
  yield takeLatest(Actions.loadSingleInvitesRequest, loadSingleInvites);

  yield takeLatest(Actions.reflectUpdatedInviteODMRequest, reflectUpdatedInviteODM);

  yield takeLatest(Actions.loadReportsRequest, loadReports);
  yield takeLatest(Actions.createReportRequest, createReport);
  yield takeLatest(Actions.deleteReportRequest, deleteReport);
  yield takeLatest(Actions.reflectUpdatedReportODMRequest, reflectUpdatedReportODM);
  yield takeLatest(Actions.setReportODMRequest, setReportODM);

  yield takeLatest(Actions.loadCommunicationRequestsRequest, loadCommunicationRequests);
  yield takeLatest(Actions.updateCommunicationRequestRequest, updateCommunicationRequest);
  yield takeLatest(Actions.deleteCommunicationRequestRequest, deleteCommunicationRequest);
  yield takeLatest(
    Actions.reflectUpdatedCommunicationRequestODMRequest,
    reflectUpdatedCommunicationRequestODM
  );

  yield takeLatest(Actions.loadCommunicationTemplatesRequest, loadCommunicationTemplates);
  yield takeLatest(Actions.updateCommunicationTemplateRequest, updateCommunicationTemplate);
  yield takeLatest(Actions.deleteCommunicationTemplateRequest, deleteCommunicationTemplate);
  yield takeLatest(
    Actions.reflectUpdatedCommunicationTemplateODMRequest,
    reflectUpdatedCommunicationTemplateODM
  );

  yield takeLatest(Actions.prosecuteCampaignRequest, prosecuteCampaign);
}
